<template>
  <pf-background-image
    v-if="!app.isInIframe"
    :src="backgroundImage"
    :style="{
      '--pf-v6-c-background-image--BackgroundImage': 'linear-gradient(transparent, #111 1080px), url(https://www.artera.net/wp-content/uploads/2018/05/main-photo.jpg)',
      '--pf-v6-c-background-image--BackgroundSize--width': '100%',
      '--pf-v6-c-background-image--BackgroundSize--max-width': 'none',
      '--pf-v6-c-background-image--BackgroundPosition': 'top left',
    }"
  />

  <pf-login-page :title="app.isInIframe ? '' : title" :subtitle="subtitle" :text-content="textContent" footer-list-variants="inline" :brand-img-src="app.isInIframe ? undefined : LogoSVG">
    <slot />

    <template v-if="$slots.utilities" #utilities>
      <slot name="utilities" />
    </template>

    <template #footerListItems>
      <pf-list-item>
        <a
          class="login-pf-page-footer-link"
          href="https://www.artera.net/it/termini-e-condizioni/"
          target="_blank"
          rel="noopener"
        >
          {{ $t('Termini di Utilizzo') }}
        </a>
      </pf-list-item>
      <pf-list-item>
        <a
          class="login-pf-page-footer-link"
          href="https://www.artera.net/it/informativa-privacy/"
          target="_blank"
          rel="noopener"
        >
          {{ $t('Privacy') }}
        </a>
      </pf-list-item>
    </template>

    <template v-if="$slots.social" #social>
      <slot name="social" />
    </template>

    <template v-if="$slots['forgot-credentials']" #forgot-credentials>
      <slot name="forgot-credentials" />
    </template>

    <template v-if="$slots.signup" #signup>
      <slot name="signup" />
    </template>
  </pf-login-page>
</template>

<style lang="scss">
.login-buttons {
  margin: 0 auto;
  width: 250px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > * {
    height: 40px;
  }

  > .separator {
    position: relative;
    line-height: 40px;
    text-transform: uppercase;
    text-align: center;
    font-size: 1em;

    > span {
      position: relative;
      background-color: var(--pf-v6-c-login__main--BackgroundColor);
      z-index: 1;
      padding: 5px 10px;
    }

    &:after {
      display: block;
      content: '';
      border-top: 1px solid var(--pf-v6-c-login__main-footer-band--BorderBlockStartColor);
      position: relative;
      top: -21px;
      z-index: 0;
    }
  }

  .btn-linkedin {
    background-color: #0077b5;
    color: white;
    border-radius: 4px;
    font-weight: bold;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    padding-left: 0;
    text-decoration: none;

    &:hover {
      background-color: #0369a0;
    }

    &:active {
      background-color: #066093;
    }

    > span {
      flex-grow: 1;
      text-align: center;
    }

    > img {
      flex-grow: 0;
      background-color: #0077b5;
      border-radius: 4px;
      box-shadow: 2px 0 rgba(0,0,0,.1);
      padding: 5px;
      height: 40px;
      width: 40px;
    }
  }
}
</style>

<script lang="ts" setup>
import { $t } from '@/i18n';
import { useAppStore } from '@/store/app';
import LogoSVG from '@/assets/logo.svg';

type Props = {
  /** Content rendered inside of the text component of the login page */
  textContent?: string;
  /** Title for the login main body header of the login page */
  title: string;
  /** Subtitle for the login main body header of the login page */
  subtitle?: string;
};

defineProps<Props>();

const $slots = defineSlots<{
  default: (props?: Record<never, never>) => any;
  utilities: (props?: Record<never, never>) => any;
  social: (props?: Record<never, never>) => any;
  'forgot-credentials': (props?: Record<never, never>) => any;
  signup: (props?: Record<never, never>) => any;
}>();

const app = useAppStore();

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const backgroundImage = 'https://www.artera.net/wp-content/uploads/2018/05/main-photo.jpg';
</script>
